<template>
  <div id="main-page" class="flex-grow-1 h-100" ref="scrollArea">
    <alert-bar />
    <breadcrumb class="mb-3" />
    <div class="m-3">
      <transition name="slide-fade">
        <router-view />
      </transition>
      <img class="icool-logo" alt="icool logo" :src="icoolLogo" />
    </div>
  </div>
</template>

<script>
import IcoolLogo from '@/assets/icool-white.png';
import Breadcrumb from '@/components/Breadcrumb.vue';
import AlertBar from '@/components/AlertBar.vue';

export default {
  name: 'MainContent',
  data() {
    return {
      icoolLogo: IcoolLogo,
    };
  },
  components: {
    AlertBar,
    Breadcrumb,
  },
  watch: {
    $route() {
      this.$refs.scrollArea.scrollTo(0, 0);
    },
  },
};
</script>

<style scoped>

</style>
